import { createGlobalStyle } from 'styled-components'
import Avenir from '../assets/fonts/avenir-roman.woff'
import TiemposWoff from '../assets/fonts/tiempos.woff'
import TiemposWoff2 from '../assets/fonts/tiempos.woff2'

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-family: 'Avenir';
    src: url(${Avenir}) format('woff')
  }
  @font-face {
    font-family: 'Tiempos';
    src: url(${TiemposWoff}) format('woff'),
        url(${TiemposWoff2}) format('woff2')
  }

  * {
    margin: 0;
    padding: 0;
    outline: 0;
    box-sizing: border-box;
  }
  html, body, #root, .App {
    height: 100%;
    width: 100%;
  }
  body {
    -webkit-font-smoothing: antialiased !important;
  }
  body, input, button {
    font-family: 'Avenir', serif;
    font-size: 16px;
  }
  select {
    box-shadow:none;   
    outline:none;      
    -webkit-appearance: none;
    -moz-appearance: none;
    background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb24tdGFibGVyLWNoZXZyb24tZG93biIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIj48L3BhdGg+PHBvbHlsaW5lIHBvaW50cz0iNiA5IDEyIDE1IDE4IDkiPjwvcG9seWxpbmU+PC9zdmc+) no-repeat 100% 50%;
    background-size: 16px;
  }
  h1, h2, h3, h4, h5, h6 {
    font-weight: 700;
  }
  button {
    cursor: pointer;
  }
  div, main {
    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #EFEFEF;
      border-radius: 8px;
    }

    &::-webkit-scrollbar-thumb {
      background: #C8C8C8;
      border-radius: 8px;
    }
  }

  .react-modal-overlay {
    background: rgba(0,0,0,0.3);
    z-index: 999;

    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;

    display: flex;
    align-items: center;
    justify-content: center;
  }

  .react-modal-content {
    width: fit-content;
    background: #fff;
    padding: 24px;
    position: relative;
    border-radius: 2px;
    border: 2px solid #CED8D8;
  }

  .no-click {
    pointer-events: none;
  }
`